// extracted by mini-css-extract-plugin
export default {"SearchHistory":"bglqt","skeleton-progress":"msyzg"};